import React from 'react';
import { motion } from 'framer-motion';
import { cls } from '@/lib/utils';
import {
  buildWordMotionProperties,
  buildCharMotionProperties,
  type Axis,
} from './animations';

export interface StaggeredTextProperties {
  axis?: Axis;
  axisValue?: number;
  delay?: number;
  staggerChildren?: number;
  children: string;
}

export default function StaggeredText({
  axis = 'y',
  axisValue = -30,
  delay = 0.2,
  staggerChildren = 0.04,
  children,
}: StaggeredTextProperties) {
  if (typeof children !== 'string') return null;

  return children.split(' ').map((word, wordIndex) => (
    <motion.span
      key={`${word}-${wordIndex.toString()}`}
      className={cls`inline-block whitespace-nowrap mr-2`}
      aria-hidden="true"
      {...buildWordMotionProperties({
        delay,
        index: wordIndex,
        staggerChildren,
      })}
    >
      {word.split('').map((char, charIndex) => (
        <motion.span
          key={`${char}-${charIndex.toString()}`}
          className="inline-block mr-[-0.05em]"
          aria-hidden="true"
          {...buildCharMotionProperties({ axis, value: axisValue })}
        >
          {char}
        </motion.span>
      ))}
    </motion.span>
  ));
}
